import { OptionIcon, OptionsContainer } from './styles';

type MessageOptionsProps = {
  isLiked: boolean;
  setIsLiked: (isLiked: boolean) => void;
  handleAnswer: () => void;
  handleModal: () => void;
}

export default function MessageOptions({ isLiked, setIsLiked, handleAnswer, handleModal }: MessageOptionsProps) {
  return (
    <OptionsContainer>
      <OptionIcon onClick={() => setIsLiked(!isLiked)}>
        <MessageHeart />
      </OptionIcon>
      <OptionIcon onClick={handleAnswer}>
        <FowardIcon />
      </OptionIcon>
      <OptionIcon onClick={handleModal}>
        <Dotshorizontal />
      </OptionIcon>
    </OptionsContainer>
  );
}

function MessageHeart() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      fill="none"
      viewBox="0 0 20 21"
    >
      <path
        fill="#F33333"
        stroke="#F33333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.378"
        d="M16.766 5.319a4.21 4.21 0 00-5.955 0L10 6.13l-.812-.811a4.21 4.21 0 00-5.955 5.955l.812.811L10 18.04l5.955-5.955.811-.811a4.21 4.21 0 000-5.955z"
      ></path>
    </svg>
  );
}

function FowardIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      fill="none"
      viewBox="0 0 16 17"
    >
      <path
        stroke="#4D4D4D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        d="M6 10.3L2.665 6.967l3.333-3.333"
      ></path>
      <path
        stroke="#4D4D4D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        d="M13.333 14.3V9.633a2.667 2.667 0 00-2.667-2.666h-8"
      ></path>
    </svg>
  );
}

function Dotshorizontal() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      fill="none"
      viewBox="0 0 16 17"
    >
      <path
        fill="#4D4D4D"
        d="M8 9.634A.667.667 0 108 8.3a.667.667 0 000 1.334zM8 4.967a.667.667 0 100-1.333.667.667 0 000 1.333zM8 14.3a.667.667 0 100-1.333.667.667 0 000 1.333z"
      ></path>
      <path
        stroke="#4D4D4D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.29"
        d="M8 9.634A.667.667 0 108 8.3a.667.667 0 000 1.334zM8 4.967a.667.667 0 100-1.333.667.667 0 000 1.333zM8 14.3a.667.667 0 100-1.333.667.667 0 000 1.333z"
      ></path>
    </svg>
  );
}


